var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-map-container"},[_c('div',{staticClass:"stats-section"},[_c('ContentMapNum')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-section"},[_c('div',{staticClass:"map-chart",attrs:{"id":"china-map"}})])
}]

export { render, staticRenderFns }